<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
	
	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);
	let settings = $settingsStore;

	let value = settings.dcpower;
	let cacheValue = value;
	let loading = false;
	let localIp = get_local_ip(id);
	const options = ['12v', '24v'];

	const setVoltage = (val) => {
		value = val;
	};

	const saveDcVoltage = async () => {
		if (cacheValue !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					dcpower: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/settings/dcpower`, {
					id,
					dcpower: value,
				});
			}

			if (res.isok) {
				toast.open({
					type: 'success',
					title:
						$format('dc_supply_voltage_scc_toast', {
							values: { value: value === 0 ? 12 : 24 },
						}) || `Voltage was changed to ${value === 0 ? '12v' : '24v'}`,
				});
				settings.supply_voltage = value;
				devices_settings.update_devices_settings(id, settings);
				cacheValue = value;
			} else {
				value = cacheValue;
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			loading = false;
		}
	};
</script>

{#each options as _type, i}
	<Radio
		size="m"
		selected={value.toString()}
		value={i.toString()}
		on:click={() => setVoltage(i)}
		id="radio-siafql6">{options[i]}</Radio
	>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={saveDcVoltage}
	>{$format('button_save')}</Button
>
